import React, { useState, useEffect } from "react";
import { FaMinusSquare, FaPlusSquare, FaTrash, FaUserCheck } from "react-icons/fa";
import Universalheader from "../Headers/universalheader";
import { formatprice } from "../Utils/functions";
import { getsessioncart, setsessioncart, setsessionhouse } from "../Utils/sessions";
import { Link, useNavigate } from "react-router-dom";
import "./cart.css";
import styles from "./../Chats/style.module.css";
import { admindetails } from "../Utils/defaults";

const Cart = () => {
    const navigate = useNavigate()

    const cartitems = getsessioncart()
    const [nothing, setnothing] = useState(false);
    const [opacity, setopacity] = useState(1);
    const [cartsum, setcartsum] = useState('');

    useEffect(() => {
        getsum(cartitems ? cartitems : []);
    }, [])



    const getsum = (e) => {
        const gh = [];
        for (const element of e) {
            gh.push(parseInt(element.itemprice))
        }
        let sum = 0;
        for (let i = 0; i < gh.length; i++) {
            sum += gh[i];
        }
        setcartsum(sum)
    }



    const update = () => {
        setnothing(!nothing)
    }

    const checkoutcart = () => {
        setsessionhouse(cartitems[0].status !== "paid" ? admindetails : cartitems[0])
        const formattedmessage = [];
        cartitems.forEach(element => {
            const message = `(item:${element.itemname},price:${element.itemprice},quantity:${element.itemquantity}) 
`
            formattedmessage.push(message)
        });
        navigate('/nav/chats', {
            state: {
                message: "startchart",
                items: formattedmessage,
                email: cartitems[0].status !== "paid" && cartitems[0].email,
                phone: cartitems[0].status !== "paid" && cartitems[0].phone
            }
        })
    }

    return (
        <div>
            <Universalheader />

            <div className="foodsandheaderwrap" style={{ opacity: opacity, paddingBottom: 350 }}>
                <div className={styles.linksdiv}>
                    <Link to="/nav" style={{ textDecoration: "none" }}>
                        <a>Home  /</a>
                    </Link>
                    <a onClick={() => navigate(-1)} style={{ cursor: "pointer", textDecoration: "none" }}>Back  /</a>
                    <a style={{ cursor: "pointer" }}>cart</a>
                </div>
                <div className="cartsummarydiv">
                    <div className="foodsheader" >
                        Cart Summary
                    </div>
                    <br />
                    <hr style={{ fontSize: 0.5 }} color="#d3d1cd" /><br />
                    <div style={{ display: "flex" }}>
                        <div>Subtotal </div> <div className="cartsumno">Ksh {formatprice(cartsum)}</div>
                    </div>
                    <br />
                    <hr style={{ fontSize: 0.5 }} color="#d3d1cd" />
                    <br />
                    <FaUserCheck size={20} color="#ff9334" style={{ marginRight: 5 }} /> Eazipay<br /><br />
                    <br />

                    <button className="checkoutbutton" onClick={checkoutcart}>CHECKOUT KSH {cartsum}</button>
                    <br />
                </div>
                <div className="branchbody">
                    <div className="foodsheader" >
                        Cart({cartitems?.length})
                    </div>
                    <hr style={{ fontSize: 0.5 }} color="#670600" />
                    {cartitems ? cartitems.map((val, key) => {
                        console.log(val)

                        //add quantity of an item in cart
                        const addquantity = () => {
                            var index = cartitems.findIndex(obj => obj?.id == val.id);
                            const price = parseInt(val.itemprice) / parseInt(val.itemquantity);
                            cartitems[index].itemprice = parseInt(val.itemprice) + price;

                            const gh = val.itemquantity + 1;
                            cartitems[index].itemquantity = gh;
                            setsessioncart(cartitems);
                            update();
                            getsum(cartitems);
                        }

                        //reduce quantity of an item in cart
                        const Reducequantity = () => {
                            var index = cartitems.findIndex(obj => obj?.id == val.id);
                            const price = parseInt(val.itemprice) / parseInt(val.itemquantity);
                            cartitems[index].itemprice = parseInt(val.itemprice) - price;
                            const gh = val.itemquantity - 1;

                            cartitems[index].itemquantity = gh;
                            setsessioncart(cartitems);
                            update();
                            getsum(cartitems);
                        }


                        //remove item from cart
                        const removeitem = () => {
                            var index = cartitems.findIndex(obj => obj?.id == val.id);
                            delete cartitems[index];
                            const results = cartitems.filter(element => {
                                return element !== null;
                            });
                            setsessioncart(results)
                            update();
                            getsum(results);

                        }

                        return (
                            <div key={key} >
                                <div className="cartitemdiv">
                                    <img src={val.itemurl} className="cartitemimage" />
                                    <div className="itemcartcontent">
                                        <div style={{ fontWeight: "bold", fontFamily: "monospace", fontSize: 20 }}>{val.itemname}</div>
                                        <div style={{ fontFamily: "monospace" }}>{val.itemdescription}</div>
                                        <div style={{ fontFamily: "monospace" }}>In stock</div>
                                    </div>
                                    <div className="cartitemprice">
                                        Ksh &nbsp;{formatprice(val.itemprice)}<br />
                                        <div style={{ fontWeight: "normal", color: "gray" }}><strike>Ksh {formatprice(parseInt(val.itemprice) + 60)}</strike></div>
                                    </div>
                                </div>
                                <br />
                                <div className="bottomcartdiv">
                                    <button onClick={removeitem}><FaTrash /> DELETE</button>
                                    <div className="bottomcartbuttons">
                                        <FaMinusSquare color="#ff9334" style={{ cursor: "pointer", opacity: 0.5 }} onClick={val.itemquantity > 1 ? Reducequantity : ""} />
                                        <div className="cartcardquantity">{val.itemquantity}</div>
                                        <FaPlusSquare style={{ cursor: "pointer" }} color="#ff9334" onClick={addquantity} />
                                    </div>
                                </div>
                                <br />
                                <hr style={{ fontSize: 0.5 }} color="#d3d1cd" />
                            </div>
                        )
                    }) :
                        <div>You dont have any items in cart at the moment</div>
                    }


                </div>
            </div>
        </div>
    )
}

export default Cart;